import { IBERDROLA_VARS } from '../config'
import { FUNDO_AMBIENTAL_HTML } from './fundoAmbientalHTML'

const ALIAS = 'fundo-ambiental-modal'
const createNode = (node) => document.createElement(node)

function loadStyleSheet () {
  const styleSheet = createNode('link')
  styleSheet.href = IBERDROLA_VARS.PATHS.CSS_TO_POP_UP
  styleSheet.rel = 'stylesheet'
  document.head.appendChild(styleSheet)
}

function $overlay () {
  const modalOverlay = createNode('div')
  modalOverlay.classList.add(`${ALIAS}__overlay`)
  modalOverlay.innerHTML = FUNDO_AMBIENTAL_HTML
  return modalOverlay
}

export function createFundoAmbientalModal () {
  loadStyleSheet()

  return $overlay()
}
